<form>
    <br />
    <div class="row">
        <div class="col-md-4">
            <input class="form-control" type="file" #fileInput [disabled]="isUploading" />
        </div>
        <div class="col-md-6">
            <button type="button" class="btn btn-primary" (click)="uploadFiles();"
                [disabled]="isUploading || user.Role == 'ReadOnly'">
                {{ isUploading ? 'Uploading...' : 'Upload File' }}
            </button>
        </div>
    </div>

    <div *ngIf="isUploading" class="mt-2" role="status">
        Uploading {{ uploadedRows }} of {{ totalRows }} rows
        <progress [max]="totalRows" [value]="uploadedRows"></progress>
    </div>

    <div>
        <h4 *ngIf="!message" class="alert-success">Excel file has been successfully uploaded</h4>
    </div>

    <div *ngIf="RemainingContractDataCount > 0">
        <h2 style="font-size: 15px;" class="alert-info">Message</h2>
        <hr style="margin: 0; border: lightgray solid 0.5px;">
        <br />
        <table class="table table-bordered col-md-4">
            <thead>
                <tr>
                    <th>Row</th>
                    <th>Column</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let _error of RemainingContractData">
                    <td>{{ _error.Key }}</td>
                    <td>{{ _error.Value }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="ErrorResponseCount > 0">
        <hr *ngIf="RemainingContractDataCount > 0" style="margin: 0;border: lightgray solid 0.5px;">

        <h2 style="font-size: 15px;" class="alert-danger">
            The following records could not be uploaded due to errors.
            <span *ngIf="SuccessCount > 0">
                <b>{{ SuccessCount }} records were uploaded successfully.</b>
            </span>
            <b>{{ FailureCount }} records failed.</b> Please refer to the details below to correct the errors and try
            again.
        </h2>
        <hr style="margin: 0; border: lightgray solid 0.5px;">
        <br />
        <table class="table table-bordered col-md-4">
            <thead>
                <tr>
                    <th>Row</th>
                    <th>Column</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let _error of ErrorResponse">
                    <td>{{ _error.Key }}</td>
                    <td>{{ _error.Value }}</td>
                </tr>
            </tbody>
        </table>
        <h2 style="font-size: 15px" class="alert-danger">
            Note: *Please correct the above errors and try to upload it again.
        </h2>
    </div>

</form>